module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-groningen-black.svg?ce2fc890ff3efaf962ea31defc1dd7f7";